import React from 'react';
import { Brain } from 'lucide-react';

const TypingDots = () => (
  <div className="flex gap-1 items-center px-1">
    {[0, 1, 2].map(i => (
      <span
        key={i}
        className="w-1.5 h-1.5 bg-teal-400 rounded-full animate-bounce"
        style={{ animationDelay: `${i * 0.15}s` }}
      />
    ))}
  </div>
);

const Message = ({ msg }) => {
  const isUser = msg.role === 'user';
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      {!isUser && (
        <div className="w-6 h-6 rounded-full bg-teal-500/20 flex items-center justify-center flex-shrink-0 mr-2 mt-0.5">
          <Brain className="w-3 h-3 text-teal-400" />
        </div>
      )}
      <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm ${
        isUser
          ? 'bg-teal-600/30 border border-teal-500/30 text-white/90 rounded-br-sm'
          : 'bg-white/5 border border-white/10 text-white/80 rounded-bl-sm'
      }`}>
        {msg.text}
      </div>
    </div>
  );
};

export const ChatMessages = ({ messages, isGenerating, bottomRef }) => (
  <div className="px-6 py-4 space-y-4">
    {messages.map((msg, i) => (
      <Message key={`msg-${i}-${msg.role}`} msg={msg} />
    ))}
    {isGenerating && (
      <div className="flex justify-start">
        <div className="w-6 h-6 rounded-full bg-teal-500/20 flex items-center justify-center flex-shrink-0 mr-2 mt-1">
          <Brain className="w-3 h-3 text-teal-400" />
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl rounded-bl-sm px-4 py-3">
          <TypingDots />
        </div>
      </div>
    )}
    <div ref={bottomRef} />
  </div>
);
